import _ from 'underscore';
import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SearchBox } from '@fluentui/react';
import { TreeView, TreeViewProps } from '@bingads-webui-react/tree-view';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getTreeViewWithSearchBoxStyles } from './styles';
import { IconsClassNameMap } from './constants';

const TreeViewWithSearchBoxUnstyled = ({
  searchBoxPlaceholder,
  treeViewProps,
  classes,
}) => {
  const cellHeight = 33;
  const [searchValue, setSearchValue] = useState('');

  const debouncedValueUpdate = useCallback(_.debounce(n => setSearchValue(n), 250));

  const filterNodeFunc = useCallback((node) => {
    const nodeName = _.result(node.name, 'toLowerCase', '');
    return nodeName.indexOf(searchValue.toLowerCase()) !== -1;
  }, [searchValue]);

  const filterNode = useMemo(() =>
    (searchValue ? filterNodeFunc : null), [filterNodeFunc, searchValue]);

  const getClassNames = useCallback(node => [`checkbox-node-${node.id}`], []);

  return (
    <div className={classnames('tree-view-with-search-box', classes.treeViewWithSearchBox)}>
      <SearchBox
        onSearch={setSearchValue}
        onChange={(e, n) => {
          // This prevents searches from being executed too quickly.
          debouncedValueUpdate(n);
        }}
        placeholder={searchBoxPlaceholder}
      />
      <TreeView
        treeViewClassNames="tree-view-container"
        filterNode={filterNode}
        filterNodeDeep
        currentSearchValue={searchValue}
        getClassNames={getClassNames}
        iconsClassNameMap={IconsClassNameMap}
        cellHeight={cellHeight}
        {...treeViewProps}
      />
    </div>
  );
};

TreeViewWithSearchBoxUnstyled.propTypes = {
  searchBoxPlaceholder: PropTypes.string,
  treeViewProps: PropTypes.shape(TreeViewProps),
  classes: PropTypes.shape({
    treeViewWithSearchBox: PropTypes.string,
  }),
};

TreeViewWithSearchBoxUnstyled.defaultProps = {
  searchBoxPlaceholder: '',
  treeViewProps: {},
  classes: {},
};

export const TreeViewWithSearchBox =
  withDefaultStyles(TreeViewWithSearchBoxUnstyled, getTreeViewWithSearchBoxStyles);
